import React from 'react';
import PropTypes from 'prop-types';

export default function ActivityIndicator(props) {
  const {
    className, style, speed, delay
  } = props;

  const relativeTime = `${(1 / speed) * delay}s`;

  return (
    <div
      style={{...style, animationDuration: relativeTime}}
      className={"activity-spinner " + className}
    >
      <div className="activity-spinner-outer" />
      <div className="activity-spinner-inner" />
    </div>
  );
}

ActivityIndicator.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  speed: PropTypes.number,
  delay: PropTypes.number
};

ActivityIndicator.defaultProps = {
  speed: 1,
  delay: 0.8
}
